export default __webpack_public_path__ + "static/media/materials.5acbddae.svg";